import { createFileRoute } from '@tanstack/react-router'
import { requireAdminOrSuperAdmin } from '@/lib/auth-guards'
import { AnalyticsTab } from '@/features/dashboard/tabs/analytics-tab'

export const Route = createFileRoute('/_authenticated/dashboard/analytics')({
  beforeLoad: requireAdminOrSuperAdmin,
  component: AnalyticsTab,
})
